<template>
  <div class="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow duration-300">
    <div class="p-6">
      <!-- Card Header -->
      <div class="flex justify-between items-start mb-4">
        <div class="flex items-center">
          <span 
            class="material-symbols-outlined text-2xl mr-3"
            :class="{
              'text-blue-600': icon === 'quiz',
              'text-green-600': icon === 'class',
              'text-amber-600': icon === 'school',
              'text-red-600': icon === 'fact_check',
              'text-purple-600': icon === 'workspace_premium'
            }"
          >{{ icon }}</span>
          <h3 class="font-bold text-lg">{{ title }}</h3>
        </div>
        
        <div v-if="isGlobal" class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
          University Provided
        </div>
      </div>
      
      <!-- Description -->
      <p class="text-sm text-gray-600 mb-6">{{ description }}</p>
      
      <!-- Content Preview or Empty State -->
      <div v-if="hasData" class="mb-6">
        <h4 class="text-sm font-medium text-gray-700 mb-2">Preview:</h4>
        <div class="bg-gray-50 rounded-md p-3 space-y-2 border border-gray-100">
          <div 
            v-for="(item, index) in data" 
            :key="index"
            class="text-sm"
          >
            <div class="font-medium">{{ getPreviewTitle(item) }}</div>
            <div class="text-gray-600 text-xs mt-1">
              {{ getPreviewDetails(item) }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex flex-col items-center justify-center py-6 mb-6 bg-gray-50 rounded-md border border-gray-100">
        <span class="material-symbols-outlined text-3xl text-gray-300 mb-2">event_busy</span>
        <p class="text-sm text-gray-500">No data available</p>
        <p v-if="title !== 'Classes & Tutorials'" class="text-xs text-gray-400 mt-1">Check back later for updates</p>
        <p v-else class="text-xs text-gray-400 mt-1">Add your classes to see them here</p>
      </div>
      
      <!-- Actions -->
      <div class="flex justify-between items-center">
        <button
          @click="$emit('view')"
          class="px-4 py-1.5 bg-blue-900 text-white rounded hover:bg-blue-800 transition-colors"
        >
          View Full Schedule
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    hasData: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    isGlobal: {
      type: Boolean,
      default: false
    },
    previewType: {
      type: String,
      default: ''
    }
  },
  methods: {
    getPreviewTitle(item) {
      if (this.previewType === 'credits') {
        return item.label;
      }

      return item.Module || item.moduleCode || item.Title || item.title || 'Upcoming item';
    },

    getPreviewDetails(item) {
      if (this.previewType === 'credits') {
        return item.value;
      }

      if (this.previewType === 'classes' || this.title === 'Lectures & Tutorials' || this.title === 'Classes & Tutorials') {
        return [item.Day, item.Time, item.Venue, item.Type].filter(Boolean).join(' • ');
      }

      if (this.previewType === 'academicCalendar') {
        return [this.formatDate(item.Date), item.Category, item.Details].filter(Boolean).join(' • ');
      }

      if (this.previewType === 'personal') {
        return [this.formatDate(item.Date), item.Time, item.Type, item.Location].filter(Boolean).join(' • ');
      }

      return [this.formatDate(item.Date), item.Time, item.Venue].filter(Boolean).join(' • ');
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      
      let date;
      
      if (typeof dateStr === 'string' && dateStr.includes('/')) {
        // Parse MM/DD/YYYY format
        const parts = dateStr.split('/');
        date = new Date(parts[2], parts[0] - 1, parts[1]);
      } else if (dateStr instanceof Date) {
        date = dateStr;
      } else {
        try {
          date = new Date(dateStr);
        } catch (e) {
          return dateStr;
        }
      }
      
      return date.toLocaleDateString('en-US', { 
        weekday: 'short',
        month: 'short', 
        day: 'numeric'
      });
    }
  }
};
</script>

